import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lx0: null,
		insert: false,
		update: false,
		loading: false,
	},
	getters: {
		getLx0cliente: state => state.lx0?.lx0cliente ?? "",
		getLx0crt: state => state.lx0?.lx0crt ?? "",
	},
	mutations: {
		set(state, lx0) {
			state.lx0 = lx0
			if (lx0) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
		},
		setLoading: (state, loading) => (state.loading = loading),
	},
	actions: {
		async getLx0cliente({ dispatch }) {
			let lx0 = await dispatch("get")
			return lx0.lx0cliente
		},
		async get({ dispatch, commit }) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get("/Oryx/Parameters/Find")
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ dispatch, commit }) {
			commit("initForm")
			let payload = await dispatch("get").then(lx0 => {
				commit("set", lx0)
				return true
			})
			return payload
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.post("/Oryx/Parameters/Insert", store.state.lx0)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					store.dispatch("find")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Oryx/Parameters/Update", store.state.lx0)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					store.dispatch("find")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete("/Oryx/Parameters/Delete")
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					store.dispatch("find")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
